import { io, type Socket } from 'socket.io-client';
import socketEndpoint from '@/connections/socket.endpoint';
import beauthBrowser from '@/lib/beauth/beauth.browser';
import applyHandshakeToken from '@/lib/socket/socket.handshake.token';
import socketTabId from '@/lib/socket/socket.tab.id';

let socket: Socket | null = null;

export const socketInstance = (): Socket => {
    if (socket) return socket;

    const { origin, path } = socketEndpoint();

    socket = io(origin, {
        path,
        transports: ['websocket', 'polling'],
        tryAllTransports: true,
        autoConnect: false,
        withCredentials: true,
        auth: (callback) => {
            void beauthBrowser.socketToken()
                .catch(() => beauthBrowser.token())
                .then((token) => callback({ token, instanceId: socketTabId() }));
        },
    });

    applyHandshakeToken(socket);
    socket.io.on('reconnect_attempt', () => applyHandshakeToken(socket as Socket));

    return socket;
};

export default socketInstance;
